import { render, staticRenderFns } from "./NotifyAboutSurvey.vue?vue&type=template&id=7921b04d&scoped=true"
import script from "./NotifyAboutSurvey.vue?vue&type=script&lang=js"
export * from "./NotifyAboutSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7921b04d",
  null
  
)

export default component.exports